const IVA = 1.13;

export function clampFixedDiscount(amount, cap) {
  const n = Number(amount);
  if (!Number.isFinite(n) || n <= 0) return 0;
  const c = Number(cap);
  if (!Number.isFinite(c) || c <= 0) return 0;
  return Math.round(Math.min(n, c) * 100) / 100;
}

export function applyOrderFixedDiscount(lines, amount) {
  const source = Array.isArray(lines) ? lines : [];
  const sum = source.reduce(
    (s, line) => s + (Number(line.totalConDescuento) || 0),
    0
  );
  const applied = clampFixedDiscount(amount, sum);
  if (applied <= 0 || source.length === 0) {
    return { lines: source, applied: 0 };
  }

  const result = source.map((line) => ({ ...line }));
  let remaining = applied;
  for (let i = 0; i < result.length; i++) {
    const line = result[i];
    const isLast = i === result.length - 1;
    const share = isLast
      ? remaining
      : Math.round((applied * (line.totalConDescuento / sum)) * 100) / 100;
    const bounded = Math.min(share, line.totalConDescuento, remaining);
    remaining = Math.round((remaining - bounded) * 100) / 100;
    line.totalConDescuento =
      Math.round((line.totalConDescuento - bounded) * 100) / 100;
    line.descuento =
      Math.round((Number(line.descuento || 0) + bounded / IVA) * 100) / 100;
    line.totalImpuestos =
      Math.round(((line.totalConDescuento * 13) / 113) * 100) / 100;
  }

  return { lines: result, applied };
}
